(() => {
  'use strict';

  const initReveal = (scope = document) => {
    const items = scope.querySelectorAll('.br-reveal:not([data-br-reveal-ready])');
    if (!items.length) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach(item => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px' });

    items.forEach(item => {
      item.dataset.brRevealReady = 'true';
      observer.observe(item);
    });
  };

  const initHero = (scope = document) => {
    scope.querySelectorAll('[data-br-hero]').forEach(hero => {
      if (hero.dataset.brReady === 'true') return;
      hero.dataset.brReady = 'true';

      const slides = [...hero.querySelectorAll('[data-br-slide]')];
      const dots = [...hero.querySelectorAll('[data-br-dot]')];
      if (slides.length < 2) return;

      let index = 0;
      let timer;
      const delay = Math.max(3, Number(hero.dataset.autoplay || 7)) * 1000;

      const show = next => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      };

      const restart = () => {
        window.clearInterval(timer);
        if (hero.dataset.pause !== 'true') {
          timer = window.setInterval(() => show(index + 1), delay);
        }
      };

      dots.forEach((dot, i) => dot.addEventListener('click', () => {
        show(i);
        restart();
      }));

      hero.addEventListener('mouseenter', () => window.clearInterval(timer));
      hero.addEventListener('mouseleave', restart);
      restart();
    });
  };

  const initMenuTabs = (scope = document) => {
    scope.querySelectorAll('[data-br-menu]').forEach(menu => {
      if (menu.dataset.brReady === 'true') return;
      menu.dataset.brReady = 'true';

      const tabs = [...menu.querySelectorAll('[data-br-menu-tab]')];
      const panels = [...menu.querySelectorAll('[data-br-menu-panel]')];

      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const target = tab.dataset.brMenuTab;
          tabs.forEach(item => {
            const active = item === tab;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          panels.forEach(panel => panel.classList.toggle('is-active', panel.dataset.brMenuPanel === target));
        });
      });
    });
  };

  const initGallery = (scope = document) => {
    scope.querySelectorAll('[data-br-gallery]').forEach(gallery => {
      if (gallery.dataset.brReady === 'true') return;
      gallery.dataset.brReady = 'true';

      const modal = gallery.querySelector('[data-br-gallery-modal]');
      const modalImage = modal?.querySelector('img');
      const close = modal?.querySelector('[data-br-gallery-close]');
      if (!modal || !modalImage || !close) return;

      const open = button => {
        const image = button.querySelector('img');
        if (!image) return;
        modalImage.src = image.currentSrc || image.src;
        modalImage.alt = image.alt || '';
        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        close.focus();
      };

      const shut = () => {
        modal.hidden = true;
        modalImage.removeAttribute('src');
        document.documentElement.style.overflow = '';
      };

      gallery.querySelectorAll('[data-br-gallery-item]').forEach(button => {
        button.addEventListener('click', () => open(button));
      });

      close.addEventListener('click', shut);
      modal.addEventListener('click', event => {
        if (event.target === modal) shut();
      });
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !modal.hidden) shut();
      });
    });
  };




  const init = (scope = document) => {
    initReveal(scope);
    initHero(scope);
    initMenuTabs(scope);
    initGallery(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', event => init(event.target));

})();
